module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"activity":"Activity"},"de":{"activity":"Aktivität"},"fr":{"activity":"Activité"},"it":{"activity":"Attività"}}')
  delete Component.options._Ctor
}
